import { ReactNode } from 'react';
import { SidePanelSectionCard, SidePanelSectionDivider, SidePanelSectionTitle } from './styles';

interface UPSidePanelSectionProps {
  title: string;
  children: ReactNode;
  testId?: string;
}

/** A titled white card inside a side panel, matching the sections of the contract detail panel. */
const UPSidePanelSection = ({ title, children, testId }: UPSidePanelSectionProps): JSX.Element => (
  <SidePanelSectionCard data-testid={testId}>
    <SidePanelSectionTitle>{title}</SidePanelSectionTitle>
    <SidePanelSectionDivider />
    {children}
  </SidePanelSectionCard>
);

UPSidePanelSection.defaultProps = {
  testId: undefined,
};

export default UPSidePanelSection;
